<template>
  <div v-show="active === ruleForm.status">
    <el-dialog title="Tiny" :visible.sync="dialog" :width="'60%'">
      <el-form :model="ruleForm">
        <el-form-item label="Nome">
          <el-input v-model="ruleForm.configuration['txt-name']" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Token da API (api2)">
          <el-input v-model="ruleForm.configuration['txt-chave']" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="CNPJ cadastrado na Tiny">
          <el-input v-model="ruleForm.configuration['txt-cnpj']" autocomplete="off"
            placeholder="Somente números"></el-input>
        </el-form-item>
        <el-form-item label="Status do pedido que dispara a integração">
          <el-select v-model="ruleForm.configuration['slc-status']" style="width: 100%;">
            <el-option v-for="item of triggerStatus" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Status na Tiny após gerar o rastreio">
          <el-select v-model="ruleForm.configuration['slc-status-rastreio']" style="width: 100%;">
            <el-option v-for="item of trackingStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Código SEDEX">
              <el-input v-model="ruleForm.configuration['txt-sedex']" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Código PAC">
              <el-input v-model="ruleForm.configuration['txt-pac']" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Webhook de pedidos (cadastrar na Tiny)">
          <el-input disabled v-model="endpoint"></el-input>
        </el-form-item>
        <el-form-item label="Webhook de nota fiscal (cadastrar na Tiny)">
          <el-input disabled v-model="endpointInvoice"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" v-if="ruleForm.id" @click="remove()">Desativar integração</el-button>
        <el-button @click="dialog = false">Voltar</el-button>
        <el-button type="primary" @click="validate()">Validar credenciais</el-button>
        <el-button type="success" @click="save()">Salvar</el-button>
      </span>
    </el-dialog>
    <IntegrationCard image="/img/integration/tiny.png" title="Tiny"
      :status="ruleForm.status" :updatedAt="ruleForm.updatedAt" :options="ruleForm.options" :id="ruleForm.id"
      @configure="dialog = true" />
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { IntegrationService } from "@/services/customers/integration.services";
import IntegrationCard from "../components/IntegrationCard.vue";

const INTEGRATION_TYPE = "6";

// Descrições que a Tiny envia em `dados.descricaoSituacao` no webhook.
const TRIGGER_STATUS = [
  "Aprovado",
  "Autorizada",
  "Entregue",
  "Enviado",
  "Expedição",
  "Não Aprovado",
  "Pedido separado",
  "Pronto para envio",
  "Preparando Envios",
];

// Valores aceitos por pedido.alterar.situacao.php (API 2.0 da Tiny).
const TRACKING_STATUS = [
  // Sentinela: não é situação da Tiny. O integration-webhook a interpreta
  // pulando a alteração de situação do pedido.
  { value: "nao-modificar", label: "Não modificar" },
  { value: "aberto", label: "Em aberto" },
  { value: "aprovado", label: "Aprovado" },
  { value: "preparando_envio", label: "Preparando envio" },
  { value: "faturado", label: "Faturado (atendido)" },
  { value: "pronto_envio", label: "Pronto para envio" },
  { value: "enviado", label: "Enviado" },
  { value: "entregue", label: "Entregue" },
  { value: "nao_entregue", label: "Não entregue" },
  { value: "cancelado", label: "Cancelado" },
];

export default {
  name: "Integration",
  props: ["customer", "active"],
  methods: {
    setConfig(config) {
      const vm = this;
      const raw = config.configuration;
      // Preserva as chaves gravadas pelo painel legado que não aparecem no form.
      vm.ruleForm.configuration = typeof raw === "string" ? JSON.parse(raw) : { ...raw };
      if (!vm.ruleForm.configuration["slc-status-rastreio"])
        vm.ruleForm.configuration["slc-status-rastreio"] = "enviado";
      vm.ruleForm.id = config.id;
      vm.ruleForm.status = config.status;
      vm.ruleForm.updatedAt = config.updatedAt;
    },
    reset() {
      const vm = this;
      vm.ruleForm = {
        id: "",
        status: false,
        options: [],
        configuration: vm.emptyConfiguration(),
        updatedAt: "Sem registros",
      };
    },
    emptyConfiguration() {
      return {
        "txt-name": "",
        "txt-chave": "",
        "txt-cnpj": "",
        "slc-status": "",
        "slc-status-rastreio": "enviado",
        "txt-sedex": "",
        "txt-pac": "",
      };
    },
    validate() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      IntegrationService.validateCredentials({
        type: INTEGRATION_TYPE,
        configuration: JSON.stringify(vm.ruleForm.configuration),
        customer: vm.customer,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: i18n.tc("credenciais-validadas-sucesso"),
          });
        })
        .catch((error) => this.$message({ type: "error", message: error }))
        .finally(() => loading.close());
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const { configuration } = vm.ruleForm;

      const payload = {
        type: INTEGRATION_TYPE,
        configuration,
        customer: vm.customer,
      };

      const request = vm.ruleForm.id
        ? IntegrationService.update(vm.ruleForm.id, payload)
        : IntegrationService.add(payload);

      request
        .then(() => {
          setTimeout(() => vm.$emit("refresh"), 300);
          vm.dialog = false;
          this.$message({
            type: "success",
            message: i18n.tc("integracao-adicionado-sucesso"),
          });
        })
        .catch((error) => this.$message({ type: "error", message: error }))
        .finally(() => loading.close());
    },
    remove: function () {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-integracao", { id: "Tiny" }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        IntegrationService.unregister({
          customer: vm.customer,
          type: INTEGRATION_TYPE,
        })
          .then(() => {
            setTimeout(() => {
              vm.$emit("refresh");
              vm.dialog = false;
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("integracao-eliminado-sucesso"),
            });
          })
          .catch((error) => this.$message({ type: "error", message: error }))
          .finally(() => loading.close());
      });
    },
  },
  data() {
    return {
      ruleForm: {
        id: "",
        status: false,
        options: [],
        configuration: this.emptyConfiguration(),
        updatedAt: "Sem registros",
      },
      dialog: false,
      endpoint:
        "https://integracao.sistemamaisenvios.com.br/portalmaisenvios/integracoes/webhook/tiny",
      endpointInvoice:
        "https://integracao.sistemamaisenvios.com.br/portalmaisenvios/integracoes/webhook/tiny/nota-fiscal",
      triggerStatus: TRIGGER_STATUS,
      trackingStatus: TRACKING_STATUS,
    };
  },
  components: { IntegrationCard },
};
</script>
